var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-dialog',{attrs:{"show":_vm.show,"title":_vm.$t('equip.video_preview'),"width":"900"},on:{"toggleShow":_vm.handleClose}},[_c('div',{staticClass:"flex",attrs:{"slot":"main"},slot:"main"},[_c('div',{attrs:{"id":"player"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }